import { render, staticRenderFns } from "./SearchAllSongs.vue?vue&type=template&id=531fe154"
import script from "./SearchAllSongs.vue?vue&type=script&lang=ts"
export * from "./SearchAllSongs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports